// =========================== Direct S3 Upload ==========================================

import api from "./axios";

export const mediaApi = {
  getUploadUrl: async ({ fileName, contentType, mediaType, fileSize }) => {
    try {
      const res = await api.post("/media/presign", {
        fileName,
        contentType,
        mediaType,
        fileSize,
      });

      return res.data;
    } catch (error) {
      throw new Error(
        `Failed to get upload URL for "${fileName}": ${
          error.response?.data?.message || error.message
        }`
      );
    }
  },
};



// ========================================================================================

// import api from "./axios";

// export const mediaApi = {
//   getUploadUrl: async ({ fileName, contentType, mediaType, fileSize }) => {
//     const res = await api.post("/media/presign", {
//       fileName,
//       contentType,
//       mediaType,
//       fileSize,
//     });

//     return res.data;
//   },
// };
